import {http} from "Services/Http/HttpClient";

export interface UpdateMailTypeBody {
    subject?: string,
    body?: string
}

export const updateMailType = async (id: string, body: UpdateMailTypeBody): Promise<unknown> => {
    return http.patch('/mail-types/' + id, body)
}

export const previewMailType = async (id: string, params: Record<string, string>): Promise<unknown> => {
    return http.post('/mail-types/' + id + '/preview', {params})
}
